import { useState } from "react";

import { Input } from "src/design-system/Input";

export const FallbackInput: React.FC<{
  placeholder: string;
  onCommit: (value: string) => void;
}> = ({ placeholder, onCommit }) => {
  const [hasTyped, setHasTyped] = useState(false);

  return (
    <Input
      error={!hasTyped}
      placeholder={placeholder}
      onChange={() => setHasTyped(true)}
      onBlur={(e) => onCommit(e.target.value)}
    />
  );
};
